import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefresh = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m7.75 3.75 2.5-2m-2.5 2 2.5 2m-2.5-2H10a6.231 6.231 0 0 1 4.42 1.83A6.231 6.231 0 0 1 16.25 10a6.23 6.23 0 0 1-.474 2.392M12.25 16.25l-2.5 2m2.5-2-2.5-2m2.5 2H10a6.233 6.233 0 0 1-4.42-1.83A6.231 6.231 0 0 1 3.75 10c0-.847.169-1.655.474-2.392"
	})]
});
const ForwardRef = forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
